export default __webpack_public_path__ + "873ab779d7101aa99fdee5b7070d0e78.png";